const Divider = () => <span className="mx-1.5 h-0.5 w-0.5 bg-gray-600" />

export default Divider
